export class PersonalAccount {
  constructor() {
    this._personalAccount = document.querySelector('[data-personal-account]');
    this._checkbox = null;
    this._warning = null;
    this._entranceFee = null;
    this._previousFile = null;
    this._file = null;
    this._awardInputs = null;
    this._partnerInputs = null;
    this._juniorGroupInputs = null;
    this._link = null;

    this._onDocumentClickHandle = this._onDocumentClickHandle.bind(this);
    this._onCheckboxChangeHandle = this._onCheckboxChangeHandle.bind(this);
  }

  init() {
    if (!this._personalAccount) {
      return;
    }

    this._checkbox = this._personalAccount.querySelector('[data-personal-account-checkbox]');
    this._warning = this._personalAccount.querySelector('[data-personal-account-warning]');
    this._entranceFee = this._personalAccount.querySelector('[data-personal-account-entrance-fee]');
    this._previousFile = this._personalAccount.querySelector('[data-personal-account-previous-file]');
    this._file = this._personalAccount.querySelector('[data-personal-account-file]');
    this._input = this._personalAccount.querySelector('[data-personal-account-input]');
    this._awardInputs = this._personalAccount.querySelectorAll('[data-personal-account-award-input]');
    this._partnerInputs = this._personalAccount.querySelectorAll('[data-personal-account-partner-input]');
    this._juniorGroupInputs = this._personalAccount.querySelectorAll('[data-personal-account-junior-group-input]');
    this._seniorSoloInputs = this._personalAccount.querySelectorAll('[data-personal-account-senior-solo-input]');
    this._seniorDuetInputs = this._personalAccount.querySelectorAll('[data-personal-account-senior-duet-input]');
    this._link = this._personalAccount.querySelector('[data-personal-account-link]');

    if (!this._file) {
      this._file = this._createFile();
    }

    // if (!this._input) {
    //   this._input = this._createInput();
    // }

    document.addEventListener('click', this._onDocumentClickHandle);
    this._checkbox.querySelector('input[type="checkbox"]').addEventListener('change', this._onCheckboxChangeHandle);
  }

  _onDocumentClickHandle(evt) {
    const target = evt.target;

    if (target.closest('[data-select-item]')) {
      const item = target.closest('[data-select-item]');

      if (item.parentElement.closest('[data-personal-account-select="category"]')) {
        const groupSelectedItem = this._personalAccount.querySelector('[data-personal-account-select="group"] [data-select-item][aria-selected="true"]');

        if (item.dataset.selectValue === 'duet') {
          this._partnerInputs.forEach((input) => {
            input.classList.remove('is-hidden');
          });

          this._juniorGroupInputs.forEach((input) => {
            input.classList.add('is-hidden');
          });

          this._seniorSoloInputs.forEach((input) => {
            input.classList.add('is-hidden');
          });

          if (groupSelectedItem && groupSelectedItem.dataset.selectValue === 'senior') {
            this._seniorDuetInputs.forEach((input) => {
              input.classList.add('is-hidden');
            });
          }

          this._link.href = this._link.dataset.personalAccountLinkDuet;
        } else if (item.dataset.selectValue === 'solo') {
          this._partnerInputs.forEach((input) => {
            input.classList.add('is-hidden');
          });

          if (groupSelectedItem && groupSelectedItem.dataset.selectValue === 'junior') {
            this._juniorGroupInputs.forEach((input) => {
              input.classList.remove('is-hidden');
            });
          }

          if (groupSelectedItem && groupSelectedItem.dataset.selectValue === 'senior') {
            this._seniorSoloInputs.forEach((input) => {
              input.classList.remove('is-hidden');
            });

            this._seniorDuetInputs.forEach((input) => {
              if (!input.hasAttribute('data-personal-account-partner-input')) {
                input.classList.remove('is-hidden');
              } else {
                input.classList.add('is-hidden');
              }
            });
          }

          this._link.href = this._link.dataset.personalAccountLinkSolo;
        }
      }

      if (item.parentElement.closest('[data-personal-account-select="group"]')) {
        const groupSelectedItem = this._personalAccount.querySelector('[data-personal-account-select="category"] [data-select-item][aria-selected="true"]');

        if (item.dataset.selectValue === 'junior') {
          this._warning.classList.add('is-active');
          this._file.classList.remove('is-hidden');

          if (groupSelectedItem && groupSelectedItem.dataset.selectValue === 'solo') {
            this._juniorGroupInputs.forEach((input) => {
              input.classList.remove('is-hidden');
            });

            this._seniorDuetInputs.forEach((input) => {
              if (!input.hasAttribute('data-personal-account-partner-input')) {
                input.classList.remove('is-hidden');
              } else {
                input.classList.add('is-hidden');
              }
            });
          }

          if (groupSelectedItem && groupSelectedItem.dataset.selectValue === 'duet') {
            this._seniorDuetInputs.forEach((input) => {
              input.classList.remove('is-hidden');
            });
          }

          this._seniorSoloInputs.forEach((input) => {
            input.classList.add('is-hidden');
          });
        } else if (item.dataset.selectValue === 'senior') {
          this._warning.classList.remove('is-active');
          this._file.classList.add('is-hidden');

          const fee = this._entranceFee.dataset.youngerGroup;

          this._entranceFee.innerHTML = `Вступительный взнос для младшей группы участников - ${fee} ₽.`;

          this._juniorGroupInputs.forEach((input) => {
            input.classList.add('is-hidden');
          });

          if (groupSelectedItem && groupSelectedItem.dataset.selectValue === 'solo') {
            this._seniorSoloInputs.forEach((input) => {
              input.classList.remove('is-hidden');
            });

            this._seniorDuetInputs.forEach((input) => {
              input.classList.remove('is-hidden');
            });
          }

          if (groupSelectedItem && groupSelectedItem.dataset.selectValue === 'duet') {
            this._seniorSoloInputs.forEach((input) => {
              input.classList.add('is-hidden');
            });

            this._seniorDuetInputs.forEach((input) => {
              input.classList.add('is-hidden');
            });
          }
        }
      }
    }
  }

  _onCheckboxChangeHandle(evt) {
    evt.preventDefault();

    const target = evt.target;

    if (target.checked) {
      // this._checkbox.after(this._input);
      this._awardInputs.forEach((input) => {
        input.classList.remove('is-hidden');
      });
    } else {
      // this._input.remove();
      this._awardInputs.forEach((input) => {
        input.classList.add('is-hidden');
      });
    }
  }

  _createFile() {
    const formRowInput = document.createElement('div');
    formRowInput.classList.add('form-row__input');
    formRowInput.setAttribute('id', 'main_UF_APPLICATION_FROM_PARENTS');
    formRowInput.setAttribute('data-file', '');
    formRowInput.setAttribute('data-personal-account-file', '');

    const span = document.createElement('span');
    span.innerHTML = 'Заявка от родителей для участников до 14 лет (скан или фото)';

    const formRowInputWrapper = document.createElement('div');
    formRowInputWrapper.classList.add('form-row__input-wrapper');

    const label = document.createElement('label');
    label.classList.add('form-row__input-label');
    label.setAttribute('for', 'document');
    label.setAttribute('data-file-button', '');
    label.innerHTML = 'Добавить файл';

    const hiddenInput = document.createElement('input');
    hiddenInput.setAttribute('type', 'hidden');
    hiddenInput.setAttribute('name', 'UF_APPLICATION_FROM_PARENTS_old_id');
    hiddenInput.setAttribute('data-file-old-input', '');

    const input = document.createElement('input');
    input.classList.add('form-row__input-file');
    input.setAttribute('id', 'document_38');
    input.setAttribute('type', 'file');
    input.setAttribute('name', 'UF_APPLICATION_FROM_PARENTS');
    input.setAttribute('data-file-input', '');

    formRowInputWrapper.appendChild(label);
    formRowInputWrapper.appendChild(hiddenInput);
    formRowInputWrapper.appendChild(input);

    const formRowInfo = document.createElement('div');
    formRowInfo.classList.add('form-row__info');
    formRowInfo.setAttribute('data-file-info', '');

    formRowInput.appendChild(span);
    formRowInput.append(formRowInputWrapper);
    formRowInput.appendChild(formRowInfo);

    return formRowInput;
  }

  _createInput() {
    const customInput = document.createElement('div');
    customInput.classList.add('custom-input');
    customInput.setAttribute('data-personal-account-input', '');
    customInput.setAttribute('id', 'main_UF_ACT_NAME');

    const label = document.createElement('label');
    const span = document.createElement('span');
    span.classList.add('custom-input__label');
    span.innerHTML = 'Название номера';

    const input = document.createElement('input');
    input.setAttribute('type', 'text');
    input.setAttribute('name', 'UF_ACT_NAME');
    input.setAttribute('size', '30');

    label.appendChild(span);
    label.appendChild(input);
    customInput.appendChild(label);

    return customInput;
  }
}
